// possible values of storageTier field for metric suggestions: 'ARCHIVED', 'REAL_TIME'
const ARCHIVED_STORAGE_TIERS = ['ARCHIVED'];
const ARCHIVED_ROUTING_STATES = ['ARCHIVED', 'ARCHIVED_WITH_EXCEPTIONS'];
const ARCHIVED_WITH_EXCEPTIONS_ROUTING_STATE = 'ARCHIVED_WITH_EXCEPTIONS';
const ARCHIVED_METRIC_LABEL = 'Archived';
const ARCHIVED_WITH_EXCEPTIONS_LABEL = 'Archived with exceptions';
const archivedMetricStateByName = Object.create(null);

function getNormalizedRoutingState(routingState) {
    return routingState?.replace(/[\s-]+/g, '_').toUpperCase();
}

angular.module('chartbuilderUtil').service('plotSignalSuggestionService', [
    '$http',
    '$q',
    'API_URL',
    'chartbuilderUtil',
    'programTextUtils',
    'currentUser',
    'featureEnabled',
    function ($http, $q, API_URL, chartbuilderUtil, programTextUtils, currentUser, featureEnabled) {
        const SUGGEST_ENDPOINT = `${API_URL}/v2/suggest/entities`;

        function getArchivedMetricState(metricItem) {
            const { storageTier, routingState } = metricItem;
            const normalizedRoutingState = getNormalizedRoutingState(routingState);
            const hasExceptions =
                normalizedRoutingState === ARCHIVED_WITH_EXCEPTIONS_ROUTING_STATE &&
                featureEnabled('newArchivedMetricsExceptionRulesLabel');
            const isArchived =
                (ARCHIVED_STORAGE_TIERS.includes(storageTier?.toUpperCase()) ||
                    ARCHIVED_ROUTING_STATES.includes(normalizedRoutingState)) &&
                featureEnabled('archivedMetricsVisibility');

            return {
                isArchived,
                hasExceptions,
                archivedMetricLabel: hasExceptions
                    ? ARCHIVED_WITH_EXCEPTIONS_LABEL
                    : ARCHIVED_METRIC_LABEL,
            };
        }

        function cacheArchivedMetricState(metricName, archivedMetricState) {
            if (!metricName) return;

            if (archivedMetricState?.isArchived) {
                archivedMetricStateByName[metricName] = archivedMetricState;
            } else {
                delete archivedMetricStateByName[metricName];
            }
        }

        function getCachedArchivedMetricState(metricName) {
            return archivedMetricStateByName[metricName] || null;
        }

        function getSyntheticResults(q, transient, allPlots, plot, chartMode) {
            const isTransient = !!transient;
            const allRequests = [];
            if (
                plot.type === 'ratio' &&
                !programTextUtils.isExpressionInvalid(q, allPlots, plot.uniqueKey)
            ) {
                allRequests.push($q.when([{ type: 'expression', value: q }]));
            }
            const isPlotType = plot.type === 'plot';
            const isEventType = plot.type === 'event';
            const isEventChart = chartMode === 'event';
            if ((isPlotType || isTransient) && !isEventChart) {
                allRequests.push(chartbuilderUtil.getGlobResults(q));
            }
            if (isEventType || isEventChart || isTransient) {
                allRequests.push(chartbuilderUtil.getEventGlobResults(q));
            }
            return $q.all(allRequests).then(function (resps) {
                let results = [];
                resps.forEach(function (r) {
                    results = results.concat(r);
                });
                return results;
            });
        }

        function getSuggestValues(q) {
            return currentUser.orgId().then(() => {
                return $http.get(SUGGEST_ENDPOINT, { params: { partialInput: q, limit: 100 } });
            });
        }

        async function getSignalSuggestions(q, transient, allPlots, plot, chartMode) {
            const syntheticResultsPromise = getSyntheticResults(
                q,
                transient,
                allPlots,
                plot,
                chartMode
            );
            const suggestDataPromise = getSuggestValues(q);

            const [syntheticResults, suggestData] = await Promise.all([
                syntheticResultsPromise,
                suggestDataPromise,
            ]);

            let rs = syntheticResults;

            const { detector: detectors, eventType: events, metric: metrics } = suggestData.data;

            if (plot.seriesData.regExStyle) {
                rs = rs.sort(function (a, b) {
                    return b.regExStyle === 'plain' ? -1 : 1;
                });
            }

            if (chartMode !== 'event' && chartMode !== 'eventOverlay') {
                metrics.forEach((metricItem) => {
                    const { name, type, storageTier, routingState } = metricItem;
                    const archivedMetricState = getArchivedMetricState({
                        storageTier,
                        routingState,
                    });

                    cacheArchivedMetricState(name, archivedMetricState);

                    rs.push({
                        type: 'metric',
                        value: name,
                        metricType: type,
                        ...archivedMetricState,
                    });
                });
            }

            events.forEach((eventItem) => {
                rs.push({ type: 'eventTimeSeries', value: eventItem.eventType });
            });

            detectors.forEach((detectorItem) => {
                rs.push({ type: 'detectorEvents', value: detectorItem.name });
            });

            return rs;
        }

        return {
            cacheArchivedMetricState,
            getArchivedMetricState,
            getCachedArchivedMetricState,
            getSignalSuggestions,
        };
    },
]);
